import PromotionCodeApproveSection from './PromotionCodeApproveSection'
import { withPromotionCodeApproveSection } from './withPromotionCodeApproveSection'

const ConnectedPromotionCodeApproveSection = withPromotionCodeApproveSection(
  PromotionCodeApproveSection
)

export { ConnectedPromotionCodeApproveSection as PromotionCodeApproveSection }
